import { useQueryClient } from '@tanstack/react-query';
import {
    useAddNewConversationToReport,
    useAddNewReplyToConversation,
    useDeleteConversation,
    useDeleteReply,
    useGetConversationsForReport,
    useReopenConversation,
    useResolveConversation,
    useUpdateConversation,
    useUpdateReply,
} from '../api/collaboration/collaboration';

export const useCommentDataItemsForReport = (reportId?: string) => {
    const queryClient = useQueryClient();

    const {
        data: items,
        isError,
        isLoading,
        isFetching,
        queryKey: commentQueryKey,
        refetch,
    } = useGetConversationsForReport(reportId ?? '0');

    const mutationHandler = {
        mutation: {
            onSuccess: () => {
                queryClient.invalidateQueries(commentQueryKey);
            },
        },
    };

    const { mutateAsync } = useAddNewConversationToReport(mutationHandler);

    const { mutateAsync: updateConversationAsync } = useUpdateConversation(mutationHandler);

    const { mutateAsync: deleteConversationAsync } = useDeleteConversation(mutationHandler);

    const { mutateAsync: addReplyAsync } = useAddNewReplyToConversation(mutationHandler);

    const { mutateAsync: updateReplyAsync } = useUpdateReply(mutationHandler);

    const { mutateAsync: deleteReplyAsync } = useDeleteReply(mutationHandler);

    const { mutateAsync: resolveConversationAsync } = useResolveConversation(mutationHandler);

    const { mutateAsync: reopenConversationAsync } = useReopenConversation(mutationHandler);

    return {
        isLoadingItems: isLoading,
        isFetchingItems: isFetching,
        isErrorItems: isError,
        items: items?.conversations ?? [],
        mutateAsync: mutateAsync,
        updateConversationAsync,
        deleteConversationAsync,
        addReplyAsync,
        updateReplyAsync,
        deleteReplyAsync,
        resolveConversationAsync,
        reopenConversationAsync,
        refetchItems: refetch,
        queryKey: commentQueryKey,
    };
};
